const loadJS = require('loadjs')

const lazyImage = function() {
  const  options = {
    rootMargin: '500px 0px 0px 0px',
  }
  const lazyImages = $('.js-lazy-image')
  const observer = new IntersectionObserver(onIntersection, options)

  $.each(lazyImages, function(index, image) {
    observer.observe(image)
  })

  function onIntersection(entries) {
    $.each(entries, function(index, entry) {
      if (entry.isIntersecting) {
        entry.target.src = entry.target.dataset.src
        entry.target.removeAttribute('data-src')
        if (entry.target.dataset.srcset) {
          entry.target.srcset = entry.target.dataset.srcset
          entry.target.removeAttribute('data-srcset')
        }
        if (entry.target.dataset.sizes) {
          entry.target.sizes = entry.target.dataset.sizes
          entry.target.removeAttribute('data-sizes')
        }
        entry.target.classList.add('visible')

        observer.unobserve(entry.target)
      }
    })
  }
}
lazyImage()

const lazyObjectFitImage = function () {
  const  options = {
    rootMargin: '500px 0px 0px 0px',
  }
  const lazyImages = $('.js-objectImage')
  const observer = new IntersectionObserver(onIntersection, options) 
  
  lazyImages.each(function(index, image) {
    const child = image.children[0]
    if ( child ) {
      observer.observe(child)
    } else {
      image.classList.add('visible')
    }
  })
  
  function onIntersection(entries) {
    $(entries).each(function(index, entry) {
      if (entry.isIntersecting) {
        if (entry.target.dataset.src) {
          entry.target.src = entry.target.dataset.src
          entry.target.removeAttribute('data-src')
        }
        if (entry.target.dataset.srcset) {
          entry.target.srcset = entry.target.dataset.srcset
          entry.target.removeAttribute('data-srcset')
        }
        if (entry.target.dataset.sizes) {
          entry.target.sizes = entry.target.dataset.sizes
          entry.target.removeAttribute('data-sizes')
        }
        entry.target.parentElement.classList.add('visible')
  
        observer.unobserve(entry.target)
      }
    })
  }
}
lazyObjectFitImage()

const lazyBackground = function() {
  const  options = {
    rootMargin: '500px 0px 0px 0px',
  }
  const lazyBackgrounds = $('.lazy-background')
  const observer = new IntersectionObserver(onIntersection, options) 
  
  $.each(lazyBackgrounds, function(index, image) {
    observer.observe(image)
  })
  
  function onIntersection(entries) {
    $.each(entries, function(index, entry) {
      if (entry.intersectionRatio > 0) {
        if (entry.target.dataset.bg) {
          entry.target.style.backgroundImage = 'url(' + entry.target.dataset.bg + ')'
          entry.target.removeAttribute('data-bg')
          entry.target.classList.add('visible')
                      
          observer.unobserve(entry.target)
        }
      }
    })
  }
}
lazyBackground()


export const gmLazyLoad = mapEl => {

  return new Promise((resolve) => {
    const map = document.querySelector(mapEl)
    if ( !map ) {
      return
    }
  
    const options = {
      rootMargin: '500px',
      threshold: 0,
    }

    window.lazyLoadMap = function() {
      return resolve()
    } 

    const api_key = 'AIzaSyDfEbj2R0tluLwQuq_t-mTFzHGub8tblYk'

    if ( !api_key ) {
      console.log('Google maps api key is missing')
    }

    /* eslint-disable */  
    let url = `https://maps.googleapis.com/maps/api/js?callback=lazyLoadMap&key=${api_key}`

    const observer = new IntersectionObserver(
      function(entries, observer) {
        const isIntersecting = typeof entries[0].isIntersecting === 'boolean' ? entries[0].isIntersecting : entries[0].intersectionRatio > 0
        if (isIntersecting) {
          if ( typeof google === 'object' && typeof google.maps === 'object' ) { 
            resolve()
          } else {
            loadJS(url)
          }
          observer.unobserve(map)
        }
      },
      options
    )
    observer.observe(map)
    /* eslint-enable */
  })
}